import axios from "axios";
import { useEffect, useState } from "react";
import { ThreeDots } from "react-loader-spinner";
import _ from "lodash";

export default function Result({ word }) {
  let [definition, setDefinition] = useState({});

  useEffect(() => {
    if (word) {
      const getData = (response) => {
        const data = response.data;
        setDefinition(data);
      };

      const key = "tf486ac3343a3de0640fb9054f9boe8b";
      let apiUrl = `https://api.shecodes.io/dictionary/v1/define?word=${word}&key=${key}`;
      axios.get(apiUrl).then(getData);
    } else {
      console.log("There was an issue retrieving the name");
    }
  }, [word]);

  return (
    <div>
      {" "}
      {word && definition.meanings ? (
        <div className="bg-white sm:py-4">
          <div className="mx-auto max-w-7xl px-6 lg:px-8 text-left">
            <div className="mx-auto max-w-2xl lg:mx-0 lg:max-w-none">
              <h1 className="mt-2 text-pretty text-4xl font-semibold tracking-tight text-gray-900 sm:text-5xl text-left">
                {_.capitalize(`${definition.word}`)}
              </h1>
              <p className="text-lg mt-3 font-bold text-orange-500 text-left">
                / {definition.phonetic} /
              </p>

              <div className="mt-20 grid max-w-xl grid-cols-1 gap-8 text-base/7 text-gray-700 lg:max-w-none lg:grid-cols-2">
                {definition.meanings?.map((meaning, index) => (
                  <div key={index}>
                    <p className=" text-left font-semibold text-orange-500">
                      {" "}
                      {meaning.partOfSpeech}
                    </p>
                    <p className=""> {_.capitalize(`${meaning.definition}`)}</p>
                    {!meaning.example ? (
                      " "
                    ) : (
                      <p className=" italic text-gray-400">
                        e.g. : {_.capitalize(`${meaning.example}`)}
                      </p>
                    )}
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      ) : (
        <div className="flex flex-col justify-center">
          {" "}
          <div className="flex justify-center items-center">
            <ThreeDots
              visible={true}
              height="80"
              width="80"
              color="#f97316"
              radius="9"
              ariaLabel="three-dots-loading"
            />
          </div>
        </div>
      )}
    </div>
  );
}
